import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88925c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-nav flex-initial flex-shrink-0 text-gray-600" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "课表", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "评课", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass({ 'text-primary': _ctx.activePage === 'timetable' }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick('timetable')))
    }, [
      _createVNode(_component_f_icon, {
        name: "timetable",
        size: "20"
      }),
      _hoisted_2
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass({ 'text-primary': _ctx.activePage === 'rating' }),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('rating')))
    }, [
      _createVNode(_component_f_icon, {
        name: "rating",
        size: "20"
      }),
      _hoisted_3
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass({ 'text-primary': _ctx.activePage === 'status' }),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('status')))
    }, [
      _createVNode(_component_f_icon, {
        name: "my",
        size: "20"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.userLoggedIn ? '我的' : '登录'), 1)
    ], 2)
  ]))
}